export default __webpack_public_path__ + "static/media/ai.42fdf31c.png";